import { Card, CardContent, cn } from '@xhubio-saas/core-frontend/ui-components'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SettingsLayout } from '../../../layouts/SettingsLayout'
import { CONTROL_TRANSITION, FIELD_RING } from '../../auth/authUi'

/**
 * Legal page — a tab on the System page (`/system/legal`).
 * Relocated from the "Rechtliches" card on Settings → System, which itself
 * had absorbed these links when the app footer was hidden
 * (`layout.hideProtectedFooter`). This is where Datenschutz, AGB and
 * Impressum live for logged-in users, plus the CEN/DIN notice (`/licenses`).
 */
const LEGAL_LINKS = [
  { key: 'common.privacy', href: '/privacy' },
  { key: 'common.terms', href: '/terms' },
  { key: 'common.imprint', href: '/imprint' },
  { key: 'common.licenses', href: '/licenses' },
] as const

export function LegalSettingsPage() {
  const { t } = useTranslation()

  return (
    <SettingsLayout section="system">
      <div data-testid="legal-settings-page">
        <Card className="w-full max-w-md">
          <CardContent className="flex flex-col items-start gap-3">
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  'rounded-sm text-sm text-primary hover:text-[var(--primary-hover)]',
                  CONTROL_TRANSITION,
                  FIELD_RING
                )}
              >
                {t(l.key, l.key)}
              </Link>
            ))}
          </CardContent>
        </Card>
      </div>
    </SettingsLayout>
  )
}
